import { gql } from '@apollo/client'

export const UPDATE_DEALER = gql`
  mutation updateDealer($input: UpdateDealerInput!) {
    data: updateDealer(input: $input) {
      id
    }
  }
`
